import React, { useEffect, useState } from "react";
import ActiveReview from "../common/ActiveReview";
import Aside from "../common/Asside";
import Header from "../common/Header";
import InactiveReview from "../common/InactiveReview";
import RejecetedReview from "../common/RejectedReview";

function KYC() {
  const [activeTab, setActiveTab] = useState("Identity");

  const handleKycSubmit = async (inputs) => {
    const token = localStorage.getItem("token");
    const formData = new FormData();

    inputs.forEach(({ id, type }) => {
      const input = document.getElementById(id);
      if (input && input.files[0]) {
        formData.append("image", input.files[0]);
        formData.append("kyc_type", type);
      }
    });

    try {
      const response = await fetch("https://esgaming.online/api/kyc-affilaite", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("KYC Submitted Successfully!");
        console.log("Success:", result);
      } else {
        alert("Failed to submit KYC");
        console.error(result);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    }
  };

  const [kycImages, setKycImages] = useState([]);

  useEffect(() => {
    fetchKycData();
  }, []);

  const fetchKycData = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch("https://esgaming.online/api/kyc-affilaite", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setKycImages(data);
      } else {
        console.error("Failed to fetch KYC images");
      }
    } catch (error) {
      console.error("Error fetching KYC images:", error);
    }
  };

  const getImageData = (type) => {
    return kycImages.find((img) => img.kyc_type === type);
  };

  const getStatusText = (status) => {
    switch (status) {
      case "active":
        return (<ActiveReview/>);
      case "rejected":
        return (<RejecetedReview/>);
      case "inactive":
        return (<InactiveReview/>);
      default:
        return "";
    }
  };

  return (
    <div>
      <Header />
      <div className="container-flex">
        <Aside />
        <div className="main">
          <div className="page-content">
            <div className="main-inner">
              <div className="page-content-body" style={{ display: "block" }}>
                <div className="main" data-target="dashboard">
                  <div className="page-content">
                    <div className="main-inner">
                      <div className="page-content-body">
                        <div className="section">
                          <div className="section-head">
                            <h2 className="title">Affiliate KYC</h2>
                          </div>
                          <div className="section-body">
                            <ul className="section_tab">
                              <li className="section_tab-item">
                                <a
                                  className={`section_tab-link ${
                                    activeTab === "Identity" ? "active" : ""
                                  }`}
                                  onClick={() => setActiveTab("Identity")}
                                  style={{ display: "flex" }}
                                >
                                  Identity
                                </a>
                              </li>
                              <li className="section_tab-item">
                                <a
                                  className={`section_tab-link ${
                                    activeTab === "Address" ? "active" : ""
                                  }`}
                                  onClick={() => setActiveTab("Address")}
                                  style={{ display: "flex" }}
                                >
                                  Address
                                </a>
                              </li>
                            </ul>

                            {activeTab === "Identity" && (
                              <div className="section-body fade active" id="kycIdentity">
                                <form id="identityForm" noValidate="novalidate">
                                <div className="d-flex">
                                 <div className="form-group form-column form-2-col">
                                     <div className="deposit-receipt-upload">
                                     <label className="label">
                                         Upload Document Photo (Front side)
                                         <abbr title="Required">*</abbr>
                                     </label>
                                     </div>
                                     <div className="upload-box state-review" onClick={() => document.getElementById("identityFrontImage").click()}  style={{ cursor: "pointer" }}>
                                     <i  className="icon-close" />
                                     <input type="file" id="identityFrontImage" name="documentFrontImage" accept="image/*" className="upload-img" />
                                     <label className="btn-5th-xs" htmlFor="identityFrontImage">choose image</label>
                                     <img
                                        name="previewImage"
                                        src={getImageData("nid_front")?.image ? `https://esgaming.online/storage/${getImageData("nid_front").image}` : ""}
                                        className="thumb-image"
                                        style={{ display: getImageData("nid_front")?.image ? "" : "none" }}
                                        alt="Front Preview"
                                      />
                                     <input type="hidden" name="imageIsEmpty" defaultValue={1} />
                                     {getStatusText(getImageData("nid_front")?.status)}
                                     </div>
                                     <div className="tips-group">
                                     <button className="btn-ic"><span className="ic-info" /></button>
                                     <ol>
                                         <li style={{listStyleType: 'none'}}>1. Upload jpg, jpeg or png file.</li>
                                         <li style={{listStyleType: 'none'}}>2. Not over 5MB.</li>
                                         <li style={{listStyleType: 'none'}}>3. Document must contains the date of issue and the name of the person. (the document must be not older than 3 months)</li>
                                     </ol>
                                     </div>
                                     <div className="tip-error" name="frontImageError" style={{display: 'none'}}>
                                     <span className="ic-error" />
                                     <p />
                                     </div>
                                 </div>
                                 <div className="form-group form-column form-2-col">
                                     <div className="deposit-receipt-upload">
                                     <label className="label">Upload Document Photo (Back side)</label>
                                     </div>
                                     <div className="upload-box state-review" onClick={() => document.getElementById("identityBackImage").click()}  style={{ cursor: "pointer" }}>
                                     <i className="icon-close" />
                                     <input type="file" id="identityBackImage" name="documentBackImage" accept="image/*" className="upload-img" />
                                     <label className="btn-5th-xs" htmlFor="identityBackImage">choose image</label>
                                     <img
                                        name="previewImage"
                                        src={getImageData("nid_back")?.image ? `https://esgaming.online/storage/${getImageData("nid_back").image}` : ""}
                                        className="thumb-image"
                                        style={{ display: getImageData("nid_back")?.image ? "" : "none" }}
                                        alt="Front Preview"
                                      />
                                     <input type="hidden" name="imageIsEmpty" defaultValue={1} />
                                     {getStatusText(getImageData("nid_back")?.status)}
                                     
                                     </div>
                                     <div className="tips-group">
                                     <button className="btn-ic"><span className="ic-info" /></button>
                                     <ol>
                                         <li style={{listStyleType: 'none'}}>1. Upload jpg, jpeg or png file.</li>
                                         <li style={{listStyleType: 'none'}}>2. Not over 5MB.</li>
                                         <li style={{listStyleType: 'none'}}>3. Document must contains the date of issue and the name of the person. (the document must be not older than 3 months)</li>
                                     </ol>
                                     </div>
                                     <div className="tip-error" name="backImageError" style={{display: 'none'}}>
                                     <span className="ic-error" />
                                     <p />
                                     </div>
                                 </div>
                                 <div className="form-group form-column form-2-col">
                                     <div className="deposit-receipt-upload">
                                     <label className="label">Upload Handheld KYC Document Photo (Selfie)</label>
                                     </div>
                                     <div className="upload-box state-review" onClick={() => document.getElementById("identityOtherImage").click()}  style={{ cursor: "pointer" }}>
                                     <i className="icon-close" />
                                     <input type="file" id="identityOtherImage" name="documentOtherImage" accept="image/*" className="upload-img" />
                                     <label className="btn-5th-xs" htmlFor="identityOtherImage">choose image</label>
                                     <img
                                        name="previewImage"
                                        src={getImageData("nid_selfie")?.image ? `https://esgaming.online/storage/${getImageData("nid_selfie").image}` : ""}
                                        className="thumb-image"
                                        style={{ display: getImageData("nid_selfie")?.image ? "" : "none" }}
                                        alt="Front Preview"
                                      />
                                     <input type="hidden" name="imageIsEmpty" defaultValue={1} />
                                     {getStatusText(getImageData("nid_selfie")?.status)}
                                     
                                     </div>
                                     <div className="tips-group">
                                     <button className="btn-ic"><span className="ic-info" /></button>
                                     <ol>
                                         <li style={{listStyleType: 'none'}}>1. Upload jpg, jpeg or png file.</li>
                                         <li style={{listStyleType: 'none'}}>2. Not over 5MB.</li>
                                         <li style={{listStyleType: 'none'}}>3. Document must contains the date of issue and the name of the person. (the document must be not older than 3 months)</li>
                                     </ol>
                                     </div>
                                     <div className="tip-error" name="otherImageError" style={{display: 'none'}}>
                                     <span className="ic-error" />
                                     <p />
                                     </div>
                                 </div>
                                 </div>
                                 
                                  <div className="section-foot">
                                    <button
                                      className="btn-primary float-right"
                                      name="submitDocument"
                                      type="button"
                                      onClick={() =>
                                        handleKycSubmit([
                                          { id: "identityFrontImage", type: "nid_front" },
                                          { id: "identityBackImage", type: "nid_back" },
                                          { id: "identityOtherImage", type: "nid_selfie" },
                                        ])
                                      }
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </form>
                                <div id="boIdentity" />
                              </div>
                            )}

                            {activeTab === "Address" && (
                              <div className="section-body fade active" id="kycAddress">
                              <form id="addressForm" noValidate="novalidate">
                             <div className="d-flex">
                                  <div className="form-group form-column form-2-col">
                                      <label className="label bold">Document Type</label>
                                      <select className="form-control" name="documentType" aria-required="true" disabled="disabled">
                                      <option>Choose document type</option>
                                      <option value={524288}>Credit Card Statement</option>
                                      <option value={16}>Bank Statement</option>
                                      <option value={1048576}>Utilities Bill</option>
                                      </select>
                                      <div className="tip-error" style={{display: 'none'}}>
                                      <span className="ic-error" />
                                      <p />
                                      </div>
                                  </div>
                                  <div className="form-group form-column form-2-col">
                                      <label className="label bold">Proof of Address<abbr title="Required">*</abbr></label>
                                      <input className="form-control" type="text" name="documentNo" aria-required="true" placeholder="Type Address here" disabled="disabled" />
                                      <div className="tip-error" style={{display: 'none'}}>
                                      <span className="ic-error" />
                                      <p />
                                      </div>
                                  </div>
                                  </div>
                                  <div className="d-flex">
                                  <div className="form-group form-column form-2-col">
                                      <div className="deposit-receipt-upload">
                                      <label className="label">
                                          Upload Document Photo (Front side)
                                          <abbr title="Required">*</abbr>
                                      </label>
                                      </div>
                                      <div className="upload-box state-fail" onClick={() => document.getElementById("addressFrontImage").click()}  style={{ cursor: "pointer" }}>
                                      <i className="icon-close" />
                                      <input type="file" id="addressFrontImage" name="documentFrontImage" accept="image/*" className="upload-img" />
                                      <label className="btn-5th-xs" htmlFor="addressFrontImage">choose image</label>
                                      <img
                                        name="previewImage"
                                        src={getImageData("address_front")?.image ? `https://esgaming.online/storage/${getImageData("address_front").image}` : ""}
                                        className="thumb-image"
                                        style={{ display: getImageData("address_front")?.image ? "" : "none" }}
                                        alt="Front Preview"
                                      />
                                     <input type="hidden" name="imageIsEmpty" defaultValue={1} />
                                     {getStatusText(getImageData("address_front")?.status)}
                                      
                                      </div>
                                      <div className="tips-group">
                                      <button className="btn-ic"><span className="ic-info" /></button>
                                      <ol>
                                          <li style={{listStyleType: 'none'}}>1. Upload jpg, jpeg or png file.</li>
                                          <li style={{listStyleType: 'none'}}>2. Not over 5MB.</li>
                                          <li style={{listStyleType: 'none'}}>3. Document must contains the date of issue and the name of the person. (the document must be not older than 3 months)</li>
                                      </ol>
                                      </div>
                                     
                                  </div>
                                  <div className="form-group form-column form-2-col">
                                      <div className="deposit-receipt-upload">
                                      <label className="label">Upload Document Photo (Back side)</label>
                                      </div>
                                      <div className="upload-box state-fail" onClick={() => document.getElementById("addressBackImage").click()}  style={{ cursor: "pointer" }}>
                                      <i className="icon-close" />
                                      <input type="file" id="addressBackImage" name="documentBackImage" accept="image/*" className="upload-img" />
                                      <label className="btn-5th-xs" htmlFor="addressBackImage">choose image</label>
                                      <img
                                        name="previewImage"
                                        src={getImageData("address_back")?.image ? `https://esgaming.online/storage/${getImageData("address_back").image}` : ""}
                                        className="thumb-image"
                                        style={{ display: getImageData("address_back")?.image ? "" : "none" }}
                                        alt="Front Preview"
                                      />
                                     <input type="hidden" name="imageIsEmpty" defaultValue={1} />
                                     {getStatusText(getImageData("address_back")?.status)}
                                     
                                      </div>
                                      <div className="tips-group">
                                      <button className="btn-ic"><span className="ic-info" /></button>
                                      <ol>
                                          <li style={{listStyleType: 'none'}}>1. Upload jpg, jpeg or png file.</li>
                                          <li style={{listStyleType: 'none'}}>2. Not over 5MB.</li>
                                          <li style={{listStyleType: 'none'}}>3. Document must contains the date of issue and the name of the person. (the document must be not older than 3 months)</li>
                                      </ol>
                                      </div>
                                      <div className="tip-error" name="backImageError" style={{display: 'none'}}>
                                      <span className="ic-error" />
                                      <p />
                                      </div>
                                  </div>
                                  <div className="form-group form-column form-2-col">
                                      <div className="deposit-receipt-upload">
                                      <label className="label">Upload Handheld KYC Document Photo (Selfie)</label>
                                      </div>
                                      <div className="upload-box state-fail" onClick={() => document.getElementById("addressOtherImage").click()}  style={{ cursor: "pointer" }}>
                                      <i className="icon-close" />
                                      <input type="file" id="addressOtherImage" name="documentOtherImage" accept="image/*" className="upload-img" />
                                      <label className="btn-5th-xs" htmlFor="addressOtherImage">choose image</label>
                                      <img
                                        name="previewImage"
                                        src={getImageData("address_selfie")?.image ? `https://esgaming.online/storage/${getImageData("address_selfie").image}` : ""}
                                        className="thumb-image"
                                        style={{ display: getImageData("address_selfie")?.image ? "" : "none" }}
                                        alt="Front Preview"
                                      />
                                     <input type="hidden" name="imageIsEmpty" defaultValue={1} />
                                     {getStatusText(getImageData("address_selfie")?.status)}
                                      </div>
                                      <div className="tips-group">
                                      <button className="btn-ic"><span className="ic-info" /></button>
                                      <ol>
                                          <li style={{listStyleType: 'none'}}>1. Upload jpg, jpeg or png file.</li>
                                          <li style={{listStyleType: 'none'}}>2. Not over 5MB.</li>
                                          <li style={{listStyleType: 'none'}}>3. Document must contains the date of issue and the name of the person. (the document must be not older than 3 months)</li>
                                      </ol>
                                      </div>
                                      <div className="tip-error" name="otherImageError" style={{display: 'none'}}>
                                      <span className="ic-error" />
                                      <p />
                                      </div>
                                  </div>
                                  </div>
                                  <div className="section-foot">
                                     <button
                                       className="btn-primary float-right"
                                       name="submitDocument"
                                       type="button"
                                       onClick={() =>
                                         handleKycSubmit([
                                           { id: "addressFrontImage", type: "address_front" },
                                           { id: "addressBackImage", type: "address_back" },
                                           { id: "addressOtherImage", type: "address_selfie" },
                                         ])
                                       }
                                     >
                                       Submit
                                     </button>
                                   </div>
                              </form>
                              <div id="boAddress" />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <footer className="footer">
                Copyright © 2020. All rights Reserved
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KYC;
